import { createFileRoute } from '@tanstack/react-router';

import { DataSourcesView } from '../../administracja/DataSourcesView';

export const Route = createFileRoute('/administracja/zrodla-danych')({
  component: DataSourcesView,
});
